import { Component } from '@angular/core';
import { PasButtonRoundColor, PasButtonRoundComponent } from '@porsche-aftersales/frontend-toolbox';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-button-edit-renderer',
  templateUrl: './button-edit-renderer.component.html',
  styleUrls: ['./button-edit-renderer.component.scss'],
  imports: [PasButtonRoundComponent],
})
export class ButtonEditRendererComponent implements ICellRendererAngularComp {
  private params;

  public agInit(params): void {
    this.params = params;
  }

  public refresh(): boolean {
    return true;
  }

  public onClick($event): void {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something 😎
      };
      this.params.onClick(params);
    }
  }

  public readonly pasButtonRoundColor = PasButtonRoundColor;
}
